import { api } from "./index";

//!--------------------------//
//! --- event api routes --- //
//!--------------------------//

// --- events --- //
export const getEvents = (page) => api.get("/events/get?page=" + page);
export const getEvent = (id) => api.get("/events/" + id + "/get");
export const concludeEvent = (id) => api.patch("/events/" + id + "/conclude");
export const startEvent = (id) => api.patch("/events/" + id + "/start");
export const updateEventVideo = (eventData) =>
	api.patch(`/events/video/${eventData?.id}/${eventData?.mode}`, {
		video: eventData?.video,
	});

// --- submissions --- //
export const getSubmissionContent = (id) =>
	api.get(`/events/submissions/${id}/content`);
export const getEventSubmissions = (event, eventContent) => {
	const params = new URLSearchParams(eventContent).toString();
	return api.get("/events/" + event + "/submissions/get?" + params);
};
export const createEventSubmission = (formData, eventId) =>
	api.post(`/events/${eventId}/submit`, formData);

export const gradeEventSubmission = (submissionId, review) =>
	api.patch(`/events/submissions/${submissionId}/grade`, review);

// --- full level events --- //
export const checkLevelEvent = (levelData, eventId, type, check) => {
	const formData = new FormData();
	formData.append("level", JSON.stringify(levelData));
	// make sure MB64 is supported
	if (levelData?.file) formData.append("file", levelData?.file);

	if (type === "create")
		return api.post(
			`/levels?type=level&event=${eventId}&check=${check ? 1 : 0}`,
			formData,
		);
	if (type === "update")
		return api.patch(
			`/levels/${levelData?._id}/update?type=level&event=${eventId}&check=${check ? 1 : 0}`,
			formData,
		);
	return api.patch(`/levels/${levelData?._id}/checkEvent?type=level&event=${eventId}&check=${check ? 1 : 0}`);
};

// --- polls --- //
export const voteEventPoll = (eventId, vote) =>
	api.patch(`/events/${eventId}/vote`, vote);
